import { UpdateItemNumberType } from "src/app/models/enums/update-item-number-type";

export class UpdateItemNumberModel {
    constructor() {
    }

    public BookingServiceId: number;
    public NewItemNumber: number;
    public UpdateItemNumberType: UpdateItemNumberType;

}
